import { Grid, Hidden, Typography } from '@mui/material'
import { Box } from '@mui/system'
import Moon from './moon.svg'
import line from './line.svg'
import './RM.css'
import RMMobile from './RMMobile'

export default function RM2() {
  const sectionHeading = 'ROADMAP'
  return (
    <>
      <Box sx={{ position: 'relative', textAlign: 'center' }}>
        <Box>
          {' '}
          <span className="textStroke">
            <Typography
              color="white"
              fontSize={{ xs: '31px', sm: '50px', md: '74px' }}
              sx={{ letterSpacing: '0.12em' }}
            >
              {sectionHeading}
            </Typography>
          </span>
        </Box>
        <Box
          sx={{
            position: 'absolute',
            top: '10%',
            right: 0,
            left: 0,
            margin: 'auto',
          }}
        >
          <Typography
            color="white"
            fontSize={{ xs: '25px', sm: '40px', md: '64px' }}
            sx={{ letterSpacing: '0.12em' }}
          >
            {sectionHeading}
          </Typography>
        </Box>
      </Box>

      <Hidden smDown>
        <Grid
          container
          direction="row"
          height="1000px"
          alignItems="center"
          maxWidth="lg"
          margin="auto"
          justifyContent="center"
        >
          {/* 1st line */}
          <Grid item xs={2} md={2} sx={{ color: 'white', textAlign: 'right' }}>
            <img
              alt=""
              src={line}
              style={{
                verticalAlign: 'middle',
                width: '80%',
                marginTop: '-8px',
              }}
            />
          </Grid>
          {/* 1st bottom */}
          {/* <Grid
            item
            xs={2}
            md={2}
            sx={{ color: 'white', textAlign: 'center', position: 'relative' }}
          >
            <Box>
              <img
                alt=""
                src={Moon}
                style={{ verticalAlign: 'middle', width: '17%' }}
              />
              <img
                alt=""
                src={line}
                style={{ verticalAlign: 'middle', width: '80%' }}
              />
            </Box>
            <Box
              mt={3}
              sx={{ width: '130%', position: 'absolute', left: '-53%' }}
            >
              <span
                style={{
                  color: 'aqua',
                  fontWeight: 'bolder',
                  fontSize: '17px',
                }}
              >
                October
              </span>
              <br />
              <br />
              <span>October 15th : Yahoo Finance Article</span>
              <br />
              <br />
              <span>October 15th : Coinmarketcap Article</span>
              <br />
              <br />
              <span>
                October 18th : Github Repo on Solana website for Solana
                recognition
              </span>
              <br />
              <br />
              <span>October 20th : Pre – Sale</span>
              <br />
              <br />
              <span>
                <b>October 20th : Swap Solar for Solana on Solar Dex</b>
              </span>
              <br />
              <br />
              <span>October 21st to 31st: Marketing</span>
              <br />
              <br />
            </Box>
          </Grid> */}

          {/* top 2nd */}
          <Grid
            item
            xs={2}
            md={2}
            sx={{ color: 'white', textAlign: 'center', position: 'relative' }}
          >
            <Box
              mt={3}
              sx={{
                width: '130%',
                position: 'absolute',
                top: '-330px',
                left: '-53%',
              }}
              id="november"
            >
              <span>Coinmarketcap [DONE]</span>
              <br />
              <br />
              <span>Yahoo Finance [DONE]</span>
              <br />
              <br />
              <span>Bloomberg [DONE]</span>
              <br />
              <br />
              <span>PR Releases [DONE]</span>
              <br />
              <br />
              <span>Pre Sale [Pending]</span>
              <br />
              <br />
              <span>Solar Token Launch [Pending]</span>
              <br />
              <br />
              <span
                style={{
                  color: 'aqua',
                  fontWeight: 'bolder',
                  fontSize: '17px',
                }}
              >
                November
              </span>
              <br />
              <br />
            </Box>
            <Box>
              <img
                alt=""
                src={Moon}
                style={{ verticalAlign: 'middle', width: '17%' }}
              />
              <img
                alt=""
                src={line}
                style={{ verticalAlign: 'middle', width: '80%' }}
              />
            </Box>
          </Grid>

          {/* 3rd bottom */}
          <Grid
            item
            xs={2}
            md={2}
            sx={{ color: 'white', textAlign: 'center', position: 'relative' }}
          >
            <Box>
              <img
                src={Moon}
                style={{ verticalAlign: 'middle', width: '17%' }}
              />
              <img
                src={line}
                style={{ verticalAlign: 'middle', width: '80%' }}
              />
            </Box>
            <Box
              mt={3}
              sx={{ width: '130%', position: 'absolute', left: '-53%' }}
            >
              <span
                style={{
                  color: 'aqua',
                  fontWeight: 'bolder',
                  fontSize: '17px',
                }}
              >
                December
              </span>
              <br />
              <br />
              <span>Solar Labs: Weekly Development Updates</span>
              <br />
              <br />
              <span>Youtube Channel</span>
              <br />
              <br />
              <span>Lobby for Defi</span>
              <br />
              <br />
              <span>Cointelegraph Article</span>
              <br />
              <br />
              <span>Develop Staking Contract</span>
              <br />
              <br />
              <span>Staking Contract Audit</span>
              <br />
              <br />
              <span>Deploy Staking Contract for Solar on mainnet</span>
              <br />
            </Box>
          </Grid>

          {/* top 4nd */}
          <Grid
            item
            xs={2}
            md={2}
            sx={{ color: 'white', textAlign: 'center', position: 'relative' }}
          >
            <Box
              mt={3}
              sx={{
                width: '130%',
                position: 'absolute',
                top: '-440px',
                left: '-53%',
              }}
              id="botRM"
            >
              <span>Develop Trade Smart Contract</span>
              <br />
              <br />
              <span>Develop Liquidity Pools Contract</span>
              <br />
              <br />
              <span>Incorporate Liquidity Lock AMM in Pool contract</span>
              <br />
              <br />
              <span>BSC Bridge</span>
              <br />
              <br />
              <span>Audit [all smart contracts]</span>
              <br />
              <br />
              <span>Deploy to main net [all smart contracts]</span>
              <br />
              <br />
              <span>Beta Testers for Dex</span>
              <br />
              <br />
              <span>Full Roll out of Dex</span>
              <br />
              <br />
              <span
                style={{
                  color: 'aqua',
                  fontWeight: 'bolder',
                  fontSize: '17px',
                }}
              >
                January
              </span>
              <br />
              <br />
            </Box>
            <Box>
              <img
                src={Moon}
                style={{ verticalAlign: 'middle', width: '17%' }}
              />
              <img
                src={line}
                style={{ verticalAlign: 'middle', width: '80%' }}
              />
            </Box>
          </Grid>

          {/* 5th bottom */}
          <Grid
            item
            xs={2}
            md={2}
            sx={{ color: 'white', textAlign: 'center', position: 'relative' }}
          >
            <Box>
              <img
                src={Moon}
                style={{ verticalAlign: 'middle', width: '17%' }}
              />
              <img
                src={line}
                style={{ verticalAlign: 'middle', width: '80%' }}
              />
            </Box>
            <Box
              mt={3}
              sx={{ width: '130%', position: 'absolute', left: '-53%' }}
            >
              <span
                style={{
                  color: 'aqua',
                  fontWeight: 'bolder',
                  fontSize: '17px',
                }}
              >
                February
              </span>
              <br />
              <br />
              <span>Centralized Exchange Listing</span>
              <br />
              <br />
              <span>IOS and Android App</span>
              <br />
              <br />
              <span>On / Off ramp for USD Beta Testing</span>
              <br />
              <br />
            </Box>
          </Grid>

          {/* top 6nd */}
          <Grid
            item
            xs={2}
            md={2}
            sx={{ color: 'white', textAlign: 'center', position: 'relative' }}
          >
            <Box
              mt={3}
              sx={{
                width: '130%',
                position: 'absolute',
                top: '-440px',
                left: '-53%',
              }}
              id="botRM"
            >
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <span>Upgrades</span>
              <br />
              <br />
              <span>Onboard New Projects to Dex</span>
              <br />
              <br />
              <span>Extensive Marketing</span>
              <br />
              <br />
              <span
                style={{
                  color: 'aqua',
                  fontWeight: 'bolder',
                  fontSize: '17px',
                }}
              >
                March - December:
              </span>
              <br />
              <br />
            </Box>
            <Box>
              <img
                src={Moon}
                style={{ verticalAlign: 'middle', width: '17%' }}
              />
              <img
                src={line}
                style={{ verticalAlign: 'middle', width: '80%' }}
              />
            </Box>
          </Grid>
        </Grid>
      </Hidden>

      <Hidden smUp>
        <RMMobile />
      </Hidden>
    </>
  )
}
